var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listagem-exportacao-planta-memorial-comissao" },
    [
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            { staticClass: "painel-filtros" },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { lg: 8, md: 8, sm: 24 } },
                    [
                      _c("p", { staticClass: "titulo" }, [
                        _vm._v("Município:"),
                        _c("span", { staticClass: "obrigatorio" }, [
                          _vm._v(" *")
                        ])
                      ]),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width",
                          attrs: {
                            placeholder: "Selecione",
                            clearable: "clearable",
                            filterable: "filterable",
                            disabled: _vm.filtrosDesabilitadosPorPlanilha,
                            "no-match-text": "Município não encontrado"
                          },
                          on: { clear: _vm.onClearMunicipio },
                          model: {
                            value: _vm.idMunicipio,
                            callback: function($$v) {
                              _vm.idMunicipio = $$v
                            },
                            expression: "idMunicipio"
                          }
                        },
                        _vm._l(_vm.municipios, function(m) {
                          return _c("el-option", {
                            key: m.id,
                            attrs: { label: m.nome, value: m.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { lg: 8, md: 8, sm: 24 } },
                    [
                      _c("p", { staticClass: "titulo" }, [
                        _vm._v("REURB coletivo:")
                      ]),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width",
                          attrs: {
                            placeholder: "Selecione",
                            clearable: "clearable",
                            filterable: "filterable",
                            disabled:
                              _vm.filtrosDesabilitadosPorPlanilha ||
                              !_vm.idMunicipio,
                            "no-match-text": "REURB não encontrado"
                          },
                          model: {
                            value: _vm.idReurbColetivo,
                            callback: function($$v) {
                              _vm.idReurbColetivo = $$v
                            },
                            expression: "idReurbColetivo"
                          }
                        },
                        _vm._l(_vm.reurbColetivos, function(reurb) {
                          return _c("el-option", {
                            key: reurb.id,
                            attrs: {
                              label: _vm.labelReurb(reurb),
                              value: reurb.id
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { lg: 8, md: 8, sm: 24 } },
                    [
                      _c("p", { staticClass: "titulo" }, [_vm._v("Bairro:")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width",
                          attrs: {
                            placeholder: "Selecione o reurb coletivo primeiro",
                            clearable: "clearable",
                            filterable: "filterable",
                            disabled:
                              _vm.filtrosDesabilitadosPorPlanilha ||
                              !_vm.idMunicipio ||
                              _vm.bairrosDoMunicipio.length === 0,
                            "no-match-text": "Bairro não encontrado"
                          },
                          model: {
                            value: _vm.bairroSelecionado,
                            callback: function($$v) {
                              _vm.bairroSelecionado = $$v
                            },
                            expression: "bairroSelecionado"
                          }
                        },
                        _vm._l(_vm.bairrosDoMunicipio, function(b) {
                          return _c("el-option", {
                            key: b.nome,
                            attrs: { label: b.nome, value: b.nome }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { lg: 8, md: 8, sm: 24 } },
                    [
                      _c("p", { staticClass: "titulo" }, [_vm._v("Quadra:")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width",
                          attrs: {
                            placeholder: "Selecione o bairro primeiro",
                            clearable: "clearable",
                            filterable: "filterable",
                            disabled:
                              _vm.filtrosDesabilitadosPorPlanilha ||
                              !_vm.idMunicipio ||
                              !_vm.bairroSelecionado ||
                              _vm.quadras.length === 0,
                            "no-match-text": "Quadra não encontrada"
                          },
                          model: {
                            value: _vm.quadraSelecionada,
                            callback: function($$v) {
                              _vm.quadraSelecionada = $$v
                            },
                            expression: "quadraSelecionada"
                          }
                        },
                        _vm._l(_vm.quadras, function(q) {
                          return _c("el-option", {
                            key: q,
                            attrs: { label: q, value: q }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { lg: 8, md: 8, sm: 24 } },
                    [
                      _c("p", { staticClass: "titulo" }, [_vm._v("Setor:")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width select-tags-ellipsis",
                          attrs: {
                            placeholder: "Selecione",
                            multiple: "multiple",
                            "collapse-tags": "collapse-tags",
                            clearable: "clearable",
                            filterable: "filterable",
                            disabled:
                              _vm.filtrosDesabilitadosPorPlanilha ||
                              !_vm.idMunicipio,
                            "no-match-text": "Setor não encontrado"
                          },
                          model: {
                            value: _vm.setorSelecionado,
                            callback: function($$v) {
                              _vm.setorSelecionado = $$v
                            },
                            expression: "setorSelecionado"
                          }
                        },
                        _vm._l(_vm.setores, function(s) {
                          return _c("el-option", {
                            key: s.codigo,
                            attrs: { label: s.nome, value: s.codigo }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { lg: 8, md: 8, sm: 24 } },
                    [
                      _c("p", { staticClass: "titulo" }, [_vm._v("Situação:")]),
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width select-tags-ellipsis",
                          attrs: {
                            placeholder: "Selecione",
                            multiple: "multiple",
                            "collapse-tags": "collapse-tags",
                            clearable: "clearable",
                            filterable: "filterable",
                            disabled:
                              _vm.filtrosDesabilitadosPorPlanilha ||
                              !_vm.idMunicipio,
                            "no-match-text": "Situação não encontrada"
                          },
                          model: {
                            value: _vm.statusSelecionado,
                            callback: function($$v) {
                              _vm.statusSelecionado = $$v
                            },
                            expression: "statusSelecionado"
                          }
                        },
                        _vm._l(_vm.situacoes, function(s) {
                          return _c("el-option", {
                            key: s.codigo,
                            attrs: { label: s.nome, value: s.codigo }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { lg: 8, md: 8, sm: 24 } },
                    [
                      _c("p", { staticClass: "titulo" }, [
                        _vm._v("Nome do interessado:")
                      ]),
                      _c("el-input", {
                        staticClass: "full-width",
                        attrs: {
                          clearable: "clearable",
                          disabled:
                            _vm.filtrosDesabilitadosPorPlanilha ||
                            !_vm.idMunicipio
                        },
                        model: {
                          value: _vm.nomeInteressado,
                          callback: function($$v) {
                            _vm.nomeInteressado = $$v
                          },
                          expression: "nomeInteressado"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { lg: 8, md: 8, sm: 24 } },
                    [
                      _c("p", { staticClass: "titulo" }, [
                        _vm._v("CPF/CNPJ do Interessado:")
                      ]),
                      _c("el-input", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["###.###.###-##", "##.###.###/####-##"],
                            expression:
                              "['###.###.###-##', '##.###.###/####-##']"
                          }
                        ],
                        staticClass: "full-width",
                        attrs: {
                          clearable: "clearable",
                          disabled:
                            _vm.filtrosDesabilitadosPorPlanilha ||
                            !_vm.idMunicipio
                        },
                        model: {
                          value: _vm.cpfCnpjInteressado,
                          callback: function($$v) {
                            _vm.cpfCnpjInteressado = $$v
                          },
                          expression: "cpfCnpjInteressado"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { lg: 8, md: 8, sm: 24 } },
                    [
                      _c("p", { staticClass: "titulo" }, [_vm._v("Processo:")]),
                      _c("el-input", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["#########/####"],
                            expression: "['#########/####']"
                          }
                        ],
                        staticClass: "full-width",
                        attrs: {
                          clearable: "clearable",
                          disabled:
                            _vm.filtrosDesabilitadosPorPlanilha ||
                            !_vm.idMunicipio
                        },
                        model: {
                          value: _vm.numeroProcessoFiltro,
                          callback: function($$v) {
                            _vm.numeroProcessoFiltro = $$v
                          },
                          expression: "numeroProcessoFiltro"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-row", { attrs: { gutter: 10 } }, [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("span", { on: { click: _vm.exibirBuscaPorLote } }, [
                      _c("p", { staticClass: "busca" }, [
                        _vm._v("Pesquisa por lote")
                      ])
                    ]),
                    _c(
                      "el-tooltip",
                      { attrs: { effect: "dark", placement: "top-end" } },
                      [
                        _c("i", { staticClass: "el-icon-info icon-info" }),
                        _c("template", { slot: "content" }, [
                          _vm._v(
                            "Para realizar a pesquisa de mais de um processo, insira a planilha contendo os números dos processos a serem pesquisados de acordo com o modelo a seguir. "
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "btn-download",
                              on: { click: _vm.baixarModelo }
                            },
                            [_vm._v("(Baixar modelo)")]
                          )
                        ])
                      ],
                      2
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _vm.showPesquisaLote
                      ? _c("app-upload-area", {
                          attrs: {
                            id: "lote",
                            target: "publico/upload",
                            fileType: _vm.validExtensions,
                            onSuccess: _vm.onSuccess,
                            documento: _vm.file,
                            hasDownloadButton: false
                          },
                          on: { removerDocumento: _vm.limparFiltro },
                          model: {
                            value: _vm.file,
                            callback: function($$v) {
                              _vm.file = $$v
                            },
                            expression: "file"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c(
                "el-row",
                { staticClass: "button-row" },
                [
                  _c("el-button", { on: { click: _vm.limparFiltro } }, [
                    _vm._v("Limpar")
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: !_vm.podeAplicar,
                        loading: _vm.carregando
                      },
                      on: { click: _vm.aplicarFiltro }
                    },
                    [
                      _c("i", { staticClass: "icon fa fa-search" }),
                      _vm._v(" Aplicar filtro")
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      !_vm.filtroObrigatorioAplicado
        ? _c(
            "el-card",
            { staticClass: "mt-1", attrs: { shadow: "hover" } },
            [
              _c("el-alert", {
                attrs: {
                  title: "Como usar",
                  type: "info",
                  closable: false,
                  "show-icon": "show-icon",
                  description: _vm.textoOrientacao
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.filtroObrigatorioAplicado && _vm.carregando,
              expression: "filtroObrigatorioAplicado && carregando"
            }
          ],
          staticClass: "mt-1"
        },
        [
          _c("app-listagem", {
            attrs: {
              caixa: "LISTAGEM_EXPORTACAO_PLANTA_MEMORIAL",
              "has-refresh-button": true,
              "has-filtro-rapido": false,
              "ids-disabled-checkbox": _vm.idsProcessosNaoElegiveisZip,
              "show-exportar-zip-button": true,
              "loading-baixar-zip-planta-memorial": _vm.gerandoZip,
              "disable-baixar-todos-zip-planta-memorial":
                !_vm.filtroObrigatorioAplicado || _vm.totalElements == 0,
              "disable-baixar-selecionados-zip-planta-memorial": !_vm.podeBaixarSelecionadosZip,
              "json-headers": _vm.colunas,
              "json-data": _vm.items,
              totalElements: _vm.totalElements,
              pagina: _vm.listagemFiltro.pagina,
              filtro: _vm.filtroListagem,
              "dados-nao-encontrado": _vm.textoVazioTabela
            },
            on: {
              atualizarFiltro: _vm.onAtualizarFiltroRapido,
              updateListagem: _vm.onRefreshListagem,
              changePage: _vm.onChangePage,
              executar: _vm.onExecutarListagem,
              sort: _vm.onSort,
              baixarTodosZipPlantaMemorial: _vm.baixarTodosZip,
              baixarSelecionadosZipPlantaMemorial: _vm.baixarSelecionadosZip
            }
          })
        ],
        1
      ),
      _vm.showModalVisualizarProcesso && _vm.idProcesso !== null
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              idProcesso: _vm.idProcesso,
              protocolo: _vm.protocolo,
              numeroProcesso: _vm.numeroProcesso,
              tipo: _vm.tipoProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModalVisualizarProcesso = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57959b44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57959b44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/listagem/ListagemExportacaoPlantaMemorialComissao.vue
// module id = null
// module chunks = 